import { Select } from 'antd';
import { TabelaPrecoExcecaoTipoPreco } from '@/features/tabela-preco/types/enum';

export function SelectTabelaPrecoExcecaoTipo({
    value,
    disabled,
    isProduto,
    onChange,
}: {
    value?: TabelaPrecoExcecaoTipoPreco;
    disabled?: boolean;
    isProduto?: boolean;
    onChange?: (value: TabelaPrecoExcecaoTipoPreco) => void;
}) {
    const options: { label: string; value: TabelaPrecoExcecaoTipoPreco }[] = [
        {
            label: 'Preço especificado',
            value: TabelaPrecoExcecaoTipoPreco.PrecoEspecificado,
        },
        {
            label: isProduto ? 'Preço do produto' : 'Preço do pacote de barras',
            value: TabelaPrecoExcecaoTipoPreco.PrecoProdutoOuPacoteBarras,
        },
        {
            label: 'Percentual de acréscimo',
            value: TabelaPrecoExcecaoTipoPreco.PercentualAcrescimo,
        },
        {
            label: 'Percentual de desconto',
            value: TabelaPrecoExcecaoTipoPreco.PercentualDesconto,
        },
        {
            label: 'Valor de acréscimo',
            value: TabelaPrecoExcecaoTipoPreco.ValorAcrescimo,
        },
        {
            label: 'Valor de desconto',
            value: TabelaPrecoExcecaoTipoPreco.ValorDesconto,
        },
    ];

    return (
        <Select
            className='w-full'
            disabled={disabled}
            onChange={onChange}
            options={options}
            value={value}
        />
    );
}
